<template>
  <q-page padding>
    <PageHeader
      title="Listar e Criar Novas Salas de Treinamento"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Treinamento</div>
        <q-input v-model="dados.nomeTreinamento" dense outlined class="input" />
      </div>
      <div class="col-md-1 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Usuário</div>
        <q-input v-model="dados.usuario" dense outlined class="input" />
      </div>
      <div class="col-md-1 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Instrutor</div>
        <q-input v-model="dados.instrutor" dense outlined class="input" />
      </div>
      <div
        class="col-lg-2 col-md-2 col-sm-5 col-xs-5 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Inicial</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.dataInicio"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.dataInicio"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div
        class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Final</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.dataFinal"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.dataFinal"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          color="primary"
          no-caps
          label="Filtrar"
          icon="filter_alt"
          class="q-mt-sm btn-filtrar"
          @click="listarAgendamentos()"
        />
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-lg container-criar-sala"
    >
      <q-btn
        label="Criar Sala"
        no-caps
        color="brand-1"
        outline
        dense
        icon="add_circle_outline"
        class="q-mt-sm btn-criar"
        :icon-right="!criarNovaSala ? 'expand_more' : 'expand_less'"
        @click="criarNovaSala = !criarNovaSala"
      />
      <div
        v-if="criarNovaSala"
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-lg container-criar-inputs"
      >
        <div
          class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-brand-5 text-weight-bold"
        >
          <div class="q-ml-sm texto-titulo-input">Data</div>
          <q-input
            dense
            outlined
            class="input"
            placeholder="DD/MM/AAAA"
            v-model="dadosCriarSala.data"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :options="validacaodata"
                    v-model="dadosCriarSala.data"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm texto-titulo-input">Hora</div>
          <q-input dense outlined v-model="dadosCriarSala.hora" mask="time">
            <template v-slot:append>
              <q-icon name="access_time" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-time v-model="dadosCriarSala.hora">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-time>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm texto-titulo-input">Local</div>
          <q-input
            v-model="dadosCriarSala.local"
            dense
            outlined
            class="input"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm texto-titulo-input">Instrutor</div>
          <q-input
            v-model="dadosCriarSala.instrutor"
            dense
            outlined
            class="input"
          />
        </div>
        <div class="col-md-2 col-sm-7 col-xs-7">
          <div class="q-ml-sm texto-titulo-input">Treinamento</div>
          <q-select
            v-model="dadosCriarSala.treinamento"
            dense
            outlined
            class="select"
            :options="options"
            option-label="label"
            option-value="value"
            use-input
            @filter="filterFn"
          />
        </div>
        <div>
          <p></p>
          <q-btn
            label="Criar"
            dense
            color="positive"
            icon="check_circle_outline"
            no-caps
            class="q-mt-sm btn-criar-sala"
            @click="criarAgendamento()"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Lista de Salas
        </span>
      </div>
      <q-table
        :columns="columns"
        :rows="listaAgendamentos"
        :loading="loading"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        class="tabela-tamanho-fixo"
        dense
        hide-pagination
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Treinamento: </strong>
                      {{ props.row.treinamentoNome }}</span
                    >
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Local: </strong>
                      {{ props.row.local }}</span
                    >
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Instrutor: </strong>
                      {{ props.row.instrutor }}</span
                    >
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Agendado Para: </strong>
                      <span>
                        {{
                          props.row.momentoRealizacao
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        }}
                        {{ props.row.momentoRealizacao.split(" ")[1] }}
                      </span></span
                    >
                  </div>
                </div>
                <div class="col-4">
                  <div class="row col-12 justify-end">
                    <q-btn
                      color="blue-6"
                      round
                      size="md"
                      icon="add"
                      @click="detalharAgendamento(props.row.uuidAgendamento)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-treinamento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-local="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.local }}
          </q-td>
        </template>
        <template v-slot:body-cell-instrutor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.instrutor }}
          </q-td>
        </template>
        <template v-slot:body-cell-agendadoPara="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div>
              {{
                props.row.momentoRealizacao
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </div>
            <div class="q-ml-sm">
              {{ props.row.momentoRealizacao.split(" ")[1] }}
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-detalhes="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'treinamento-detalhe-agendamento',
                params: { agendamentoUuid: props.row.uuidAgendamento },
              }"
            >
              <q-btn color="blue-6" round size="sm" icon="add" />
            </router-link>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

const columns = [
  {
    name: "treinamento",
    label: "Treinamento",
    align: "left",
  },
  {
    name: "local",
    label: "Local",
    align: "left",
  },
  {
    name: "instrutor",
    label: "Instrutor",
    align: "left",
  },
  {
    name: "agendadoPara",
    label: "Agendado Para",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    align: "center",
  },
];
export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const time = ref();
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const dados = ref({
      nomeTreinamento: "",
      usuario: "",
      instrutor: "",
      dataInicio: "",
      dataFinal: "31/12/2025",
    });
    const listaAgendamentos = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    let criarNovaSala = ref(false);
    const dadosCriarSala = ref({
      data: "",
      hora: "",
      local: "",
      instrutor: "",
      treinamento: "",
    });
    const options = ref([]);
    let dataValida = new Date();

    const listarAgendamentos = async (page = 0, rowsNumber = 10) => {
      await unidade.value.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch(
          "treinamento/listarAgendamentos",
          {
            data_final: dados.value.dataFinal,
            data_inicial: dados.value.dataInicio,
            instrutor: dados.value.instrutor,
            treinamento: dados.value.nomeTreinamento,
            usuario: dados.value.usuario,
            vendor_id: unidade.value.id,
            page: page,
            per_page: rowsNumber,
          }
        );
        listaAgendamentos.value = response.data.data;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.page = response.data.current_page;
        pagination.value.rowsNumber = response.data.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarTreinamentos = async (treinamento) => {
      try {
        const response = await store.dispatch(
          "treinamento/listarTreinamentos",
          {
            unidadeId: unidade.value.id,
            treinamento: treinamento,
            per_page: 30,
          }
        );
        options.value = [];
        response.data.data.forEach((treinamento) => {
          options.value.push({
            label: treinamento.nome,
            value: treinamento.id,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const criarAgendamento = async () => {
      try {
        await store.dispatch("treinamento/criarNovoAgendamento", {
          data: dadosCriarSala.value.data,
          hora: dadosCriarSala.value.hora,
          instrutor: dadosCriarSala.value.instrutor,
          local: dadosCriarSala.value.local,
          uuid_treinamento: dadosCriarSala.value.treinamento.value,
        });
        quasar.notify({
          message: "Agendamento criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarAgendamentos();
        reset();
        criarNovaSala.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar agendamento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reset = () => {
      dadosCriarSala.value = {
        data: "",
        hora: "",
        local: "",
        instrutor: "",
        treinamento: "",
      };
    };

    const detalharAgendamento = (id) => {
      router.push({
        name: "treinamento-detalhe-agendamento",
        params: { agendamentoUuid: id },
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarAgendamentos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarAgendamentos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarAgendamentos);

    return {
      columns,
      unidade,
      dados,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      listarAgendamentos,
      listaAgendamentos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      criarNovaSala,
      dadosCriarSala,
      time,
      options,
      listarTreinamentos,
      dataValida,
      validacaodata(date) {
        let hoje = new Date();

        let ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        let dd = ontem.getDate();
        let mm = ontem.getMonth() + 1;
        let yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        let data_valida = yyyy + "/" + mm + "/" + dd;
        dataValida = data_valida;

        return date >= data_valida;
      },
      criarAgendamento,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarTreinamentos(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);

        setTimeout(() => {
          update();
        }, 1000);
      },
      detalharAgendamento,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .container-criar-sala {
    margin: 0px 0px 0px 0px;
  }
  .container-criar-inputs {
    margin: 12px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .btn-filtrar {
    margin: 0px 0px 0px 0px;
    font-size: 12px;
  }
  .btn-criar {
    margin: 20px 0px 0px 8px;
    font-size: 12px;
  }
  .btn-criar-sala {
    margin: 8px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
